function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { useGridRegisterPipeProcessor } from '@mui/x-data-grid/internals';
import { GRID_ROOT_GROUP_ID } from '@mui/x-data-grid';
import { insertNodeInTree } from "../../../utils/tree/utils.js";
export function addPinnedRow(param) {
    var groupingParams = param.groupingParams, rowModel = param.rowModel, rowId = param.rowId, position = param.position, apiRef = param.apiRef, isAutoGenerated = param.isAutoGenerated;
    var _groupingParams_additionalRowGroups, _groupingParams_additionalRowGroups_pinnedRows_position, _groupingParams_additionalRowGroups_pinnedRows, _groupingParams_additionalRowGroups1;
    var dataRowIdToModelLookup = _extends({}, groupingParams.dataRowIdToModelLookup);
    var dataRowIdToIdLookup = _extends({}, groupingParams.dataRowIdToIdLookup);
    var tree = _extends({}, groupingParams.tree);
    var treeDepths = _extends({}, groupingParams.treeDepths);
    // TODO: warn if id is already present in `props.rows`
    var node = {
        type: 'pinnedRow',
        id: rowId,
        depth: 0,
        parent: GRID_ROOT_GROUP_ID,
        isAutoGenerated: isAutoGenerated
    };
    insertNodeInTree(node, tree, treeDepths, null);
    if (!isAutoGenerated) {
        dataRowIdToModelLookup[rowId] = rowModel;
        dataRowIdToIdLookup[rowId] = rowId;
    }
    // Do not push it to ids list so that pagination is not affected by pinned rows
    apiRef.current.caches.rows.dataRowIdToModelLookup[rowId] = _extends({}, rowModel);
    apiRef.current.caches.rows.dataRowIdToIdLookup[rowId] = rowId;
    var previousPinnedRows = ((_groupingParams_additionalRowGroups = groupingParams.additionalRowGroups) === null || _groupingParams_additionalRowGroups === void 0 ? void 0 : _groupingParams_additionalRowGroups.pinnedRows) || {};
    var newPinnedRow = {
        id: rowId,
        model: rowModel
    };
    if ((_groupingParams_additionalRowGroups1 = groupingParams.additionalRowGroups) === null || _groupingParams_additionalRowGroups1 === void 0 ? void 0 : (_groupingParams_additionalRowGroups_pinnedRows = _groupingParams_additionalRowGroups1.pinnedRows) === null || _groupingParams_additionalRowGroups_pinnedRows === void 0 ? void 0 : (_groupingParams_additionalRowGroups_pinnedRows_position = _groupingParams_additionalRowGroups_pinnedRows[position]) === null || _groupingParams_additionalRowGroups_pinnedRows_position === void 0 ? void 0 : _groupingParams_additionalRowGroups_pinnedRows_position.includes(newPinnedRow)) {
        return _extends({}, groupingParams, {
            dataRowIdToModelLookup: dataRowIdToModelLookup,
            dataRowIdToIdLookup: dataRowIdToIdLookup,
            tree: tree,
            treeDepths: treeDepths
        });
    }
    return _extends({}, groupingParams, {
        dataRowIdToModelLookup: dataRowIdToModelLookup,
        dataRowIdToIdLookup: dataRowIdToIdLookup,
        tree: tree,
        treeDepths: treeDepths,
        additionalRowGroups: _extends({}, groupingParams.additionalRowGroups, {
            pinnedRows: _extends({}, previousPinnedRows, _define_property({}, position, _to_consumable_array(previousPinnedRows[position] || []).concat([
                newPinnedRow
            ])))
        })
    });
}
export var useGridRowPinningPreProcessors = function(apiRef) {
    var prevPinnedRowsCacheRef = React.useRef(null);
    var addPinnedRows = React.useCallback(function(groupingParams) {
        var _pinnedRowsCache_topIds, _pinnedRowsCache_bottomIds, _pinnedRowsCache_bottomIds1, _pinnedRowsCache_topIds1;
        var pinnedRowsCache = apiRef.current.caches.pinnedRows || {};
        var prevPinnedRowsCache = prevPinnedRowsCacheRef.current;
        prevPinnedRowsCacheRef.current = pinnedRowsCache;
        var newGroupingParams = _extends({}, groupingParams, {
            additionalRowGroups: _extends({}, groupingParams.additionalRowGroups, {
                // reset pinned rows state
                pinnedRows: {}
            })
        });
        if (prevPinnedRowsCache) {
            var _prevPinnedRowsCache_topIds, _prevPinnedRowsCache_bottomIds;
            var pinnedRowCleanup = function(rowId) {
                var node = newGroupingParams.tree[rowId];
                if ((node === null || node === void 0 ? void 0 : node.type) === 'pinnedRow') {
                    delete newGroupingParams.tree[rowId];
                    delete newGroupingParams.dataRowIdToModelLookup[rowId];
                    delete newGroupingParams.dataRowIdToIdLookup[rowId];
                    delete apiRef.current.caches.rows.dataRowIdToIdLookup[rowId];
                    delete apiRef.current.caches.rows.dataRowIdToModelLookup[rowId];
                }
            };
            (_prevPinnedRowsCache_topIds = prevPinnedRowsCache.topIds) === null || _prevPinnedRowsCache_topIds === void 0 ? void 0 : _prevPinnedRowsCache_topIds.forEach(pinnedRowCleanup);
            (_prevPinnedRowsCache_bottomIds = prevPinnedRowsCache.bottomIds) === null || _prevPinnedRowsCache_bottomIds === void 0 ? void 0 : _prevPinnedRowsCache_bottomIds.forEach(pinnedRowCleanup);
        }
        (_pinnedRowsCache_topIds = pinnedRowsCache.topIds) === null || _pinnedRowsCache_topIds === void 0 ? void 0 : _pinnedRowsCache_topIds.forEach(function(rowId) {
            newGroupingParams = addPinnedRow({
                groupingParams: newGroupingParams,
                rowModel: pinnedRowsCache.idLookup[rowId],
                rowId: rowId,
                position: 'top',
                apiRef: apiRef,
                isAutoGenerated: false
            });
        });
        (_pinnedRowsCache_bottomIds = pinnedRowsCache.bottomIds) === null || _pinnedRowsCache_bottomIds === void 0 ? void 0 : _pinnedRowsCache_bottomIds.forEach(function(rowId) {
            newGroupingParams = addPinnedRow({
                groupingParams: newGroupingParams,
                rowModel: pinnedRowsCache.idLookup[rowId],
                rowId: rowId,
                position: 'bottom',
                apiRef: apiRef,
                isAutoGenerated: false
            });
        });
        // If row with the same `id` is present both in `rows` and `pinnedRows` - remove it from the root group children
        if (((_pinnedRowsCache_bottomIds1 = pinnedRowsCache.bottomIds) === null || _pinnedRowsCache_bottomIds1 === void 0 ? void 0 : _pinnedRowsCache_bottomIds1.length) || ((_pinnedRowsCache_topIds1 = pinnedRowsCache.topIds) === null || _pinnedRowsCache_topIds1 === void 0 ? void 0 : _pinnedRowsCache_topIds1.length)) {
            var shouldKeepRow = function(rowId) {
                if (newGroupingParams.tree[rowId] && newGroupingParams.tree[rowId].type === 'pinnedRow') {
                    return false;
                }
                return true;
            };
            var rootGroupNode = newGroupingParams.tree[GRID_ROOT_GROUP_ID];
            newGroupingParams.tree[GRID_ROOT_GROUP_ID] = _extends({}, rootGroupNode, {
                children: rootGroupNode.children.filter(shouldKeepRow)
            });
            newGroupingParams.dataRowIds = newGroupingParams.dataRowIds.filter(shouldKeepRow);
        }
        return newGroupingParams;
    }, [
        apiRef
    ]);
    useGridRegisterPipeProcessor(apiRef, 'hydrateRows', addPinnedRows);
};
